import { render, staticRenderFns } from "./UCRichTextDisplay.vue?vue&type=template&id=582070e5&scoped=true&"
import script from "./UCRichTextDisplay.vue?vue&type=script&lang=ts&"
export * from "./UCRichTextDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./UCRichTextDisplay.vue?vue&type=style&index=0&id=582070e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582070e5",
  null
  
)

export default component.exports